import React from 'react';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import PlaylistAddOutlinedIcon from '@mui/icons-material/PlaylistAddOutlined';
import EditionItemsList from './EditionItemsList';

/**
 * Coluna de itens do editor: contagem, aviso dos bloqueados, "Adicionar itens" e a lista.
 * @param {{ items: Array, blockedCount: number, onAdd: Function, onMove: Function,
 *   onToggleHighlight: Function, onRemove: Function }} props
 */
function EditionItemsPanel({ items, blockedCount, onAdd, onMove, onToggleHighlight, onRemove }) {
  const highlights = items.filter((item) => item.edition_highlight).length;

  return (
    <Box sx={{ minWidth: 0 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1, mb: 1.5, flexWrap: 'wrap' }}>
        <Box>
          <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>Itens do e-mail ({items.length})</Typography>
          <Typography variant="caption" color="text.secondary">
            {highlights} destaque(s). A estrela vale só para este envio.
          </Typography>
        </Box>
        <Button variant="outlined" size="small" startIcon={<PlaylistAddOutlinedIcon />} onClick={onAdd}>
          Adicionar itens
        </Button>
      </Box>
      {blockedCount > 0 && (
        <Alert severity="warning" sx={{ mb: 1.5 }}>
          {blockedCount} item(ns) aguardando deploy. O envio só sai depois que eles estiverem no ar.
        </Alert>
      )}
      <EditionItemsList items={items} onMove={onMove} onToggleHighlight={onToggleHighlight} onRemove={onRemove} />
    </Box>
  );
}

export default EditionItemsPanel;
